module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAZCAYAAAAMhW+1AAAAGElEQVQokWPg4uL6jw8zjCoYVTCqAAMDAL683qnTZ1DuAAAAAElFTkSuQmCC"